import { pageViewEventHandler, loginEventHandler, errorViewHandler, pageNotFoundEventHandler } from "../shared/base";
import { donationWidgetLoadedEventHandler, donationAddToCartEventHandler } from "../shared/DonationWidget";
import { searchInitiatedEventHandler, searchResultsViewEventHandler, searchResultsClickEventHandler, searchFilterClickEventHandler, searchResultsErrorEventHandler } from "./SiteSearch";
import { sponAppChildInteractions, sponAppChildGridView, sponAppCardClick, sponAppPageView, sponAppChildDetailView, sponAppShareCopy, sponAppAddToCart } from "./SponApp";
import { alertBarNotificationView, alertBarClick } from "./AlertBar";
import { ghfEventsHandler } from "../shared/ghf";
import { gravityFormInView, gravityFormOnError, gravityFormOnStart, gravityFormOnSubmit } from "../shared/gravityForms";
(function (global) {
    // Pageview Event
    global.document.addEventListener("page_view", pageViewEventHandler);
    global.document.addEventListener("error_page_not_found", pageNotFoundEventHandler);
    // Login Event
    global.document.addEventListener("login_success", loginEventHandler);
    // Site Search
    global.document.addEventListener("search_initiated", searchInitiatedEventHandler);
    global.document.addEventListener("search_results_view", searchResultsViewEventHandler);
    global.document.addEventListener("search_results_click", searchResultsClickEventHandler);
    global.document.addEventListener("search_filter_click", searchFilterClickEventHandler);
    global.document.addEventListener("search_results_error", searchResultsErrorEventHandler);
    // Donation Widget 
    global.document.addEventListener("donation_widget_loaded", donationWidgetLoadedEventHandler);
    global.document.addEventListener("donation_add_to_cart", donationAddToCartEventHandler);
    // Sponsorship App
    global.document.addEventListener("spon_app_child_interaction", sponAppChildInteractions);
    global.document.addEventListener("spon_app_child_grid_view", sponAppChildGridView);
    global.document.addEventListener("spon_app_card_click", sponAppCardClick);
    global.document.addEventListener("spon_app_page_view", sponAppPageView);
    global.document.addEventListener("spon_app_child_detail_view", sponAppChildDetailView);
    global.document.addEventListener("spon_app_share_copy", sponAppShareCopy);
    global.document.addEventListener("spon_app_add_to_cart", sponAppAddToCart);
    // Gravity Forms
    global.document.addEventListener("gf_view_event", gravityFormInView);
    global.document.addEventListener("gf_start_event", gravityFormOnStart);
    global.document.addEventListener("gf_submit_success_event", gravityFormOnSubmit);
    global.document.addEventListener("gf_error_event", gravityFormOnError);
    // Global header and footer
    var ghfEvents = [
        "ghf_navigation",
        "cart_set"
    ];
    ghfEvents.forEach(function (eventKey) {
        global.document.addEventListener(eventKey, ghfEventsHandler);
    });
    // Alert Bar
    global.document.addEventListener("alert_bar_click", alertBarClick);
    global.document.addEventListener("alert_bar_notification_view", alertBarNotificationView);
    // Shared Events
    global.document.addEventListener("error_view", errorViewHandler);
})(window);
